import { useState } from 'react';
import styled from '@emotion/styled';
import { Spin, Tabs } from 'antd';

const { TabPane } = Tabs;

export interface CategoryItem {
  key: string;
  label: string;
  count: number;
}

export interface CategoryFilterProps {
  categories?: CategoryItem[];
  activeKey?: string;
  onChange?: (key: string) => void;
  loading?: boolean;
}

function CategoryFilter(props: CategoryFilterProps) {
  const { categories, activeKey: controlledActiveKey, onChange, loading } = props;

  const [internalActiveKey, setInternalActiveKey] = useState('all');

  const activeKey = controlledActiveKey ?? internalActiveKey;

  const handleChange = (key: string) => {
    setInternalActiveKey(key);
    onChange?.(key);
  };

  return (
    <StyledTabsWrapper data-sid="cf-root-01">
      {loading ? (
        <div data-sid="cf-loading-03" className="flex items-center justify-center h-[46px]">
          <Spin />
        </div>
      ) : categories ? (
        <Tabs data-sid="cf-tabs-02" activeKey={activeKey} onChange={handleChange}>
          {categories.map((item) => (
            <TabPane tab={`${item.label} (${item.count})`} key={item.key} />
          ))}
        </Tabs>
      ) : null}
    </StyledTabsWrapper>
  );
}

// 仅用于修改 antd Tabs 组件内部样式
const StyledTabsWrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 16px;
  background: var(--fett-bg-panel);
  border-bottom: 1px solid var(--theme-border-2, var(--fett-border-default));
  flex-shrink: 0;

  .ant-tabs {
    margin-bottom: 0;
  }

  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-nav::before {
    border-bottom: none;
  }

  .ant-tabs-tab {
    color: var(--fett-text-secondary);
  }
`;

export default CategoryFilter;
